import { Component, EventEmitter, Output } from '@angular/core';
import { Receptor, usoCFDI, Emisor , Select2Option } from '../../../../shared/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-form-receptor',
  standalone: false,  
  templateUrl: './form-receptor.component.html',
  styleUrl: './form-receptor.component.scss',
})

export class FormReceptorComponent {
  public isCollapsed: boolean = false;
  public isCollapsedSub: boolean = true;
  public isCollapsedSub1: boolean = true;
  public show: boolean = true;
  public isLoading_usoCfdi:boolean = false;
  public isLoading_usoRegimen:boolean = false;
  public usoCfdi!:usoCFDI;
  public data_emisor!: Emisor;
  public listavalores =[];

  public customListCatMetodoPago: Select2Option[] = [];
  public customListRegimen: Select2Option[] = [];

  @Output() public send_data_receptor: EventEmitter<Receptor> = new EventEmitter<Receptor>();
  @Output() public send_validation_receptor: EventEmitter<boolean> = new EventEmitter<boolean>();

  public formReceptor: FormGroup;
  


  constructor() 
  {
    this.formReceptor = new FormGroup({
      rfc: new FormControl('', [Validators.maxLength(13), Validators.required]),
      identificador: new FormControl(null, []),
      nombre: new FormControl('', [Validators.required]),
      numRegIdTrib: new FormControl(null, []),
      usoCFDI: new FormControl('', [Validators.required]),
      residenciaFiscal: new FormControl(null, []),
      regimenFiscal: new FormControl('', [Validators.required]),
      domicilioFiscal: new FormControl('', [Validators.maxLength(6),Validators.required,Validators.pattern('^[0-9]*$')]),
      calle: new FormControl(null, []),
      noExterior: new FormControl(null, [
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(6),
      ]),
      noInterior: new FormControl(null, []),
      colonia: new FormControl(null, []),
      municipio: new FormControl(null, []),
      estado: new FormControl(null, []),
      pais: new FormControl(null, []),
      email: new FormControl(null, [Validators.email]),
      direccionEntrega: new FormGroup({
        calle: new FormControl(null, []),
        noExterior: new FormControl(null, [Validators.pattern('^[0-9]*$')]),
        noInterior: new FormControl(null, []),
        colonia: new FormControl(null, []),
        municipio: new FormControl(null, []),
        estado: new FormControl(null, []),
        pais: new FormControl(null, []),
        codigoPostal: new FormControl(null, [Validators.maxLength(6)]),
      })
    });
  }

  ngOnInit():void{
    const customUsoCfdiString = sessionStorage.getItem("CatalogUSOCFDI");
    const customregimenString = sessionStorage.getItem("regimenFiscal");

    if (customUsoCfdiString) {
      this.customListCatMetodoPago = JSON.parse(customUsoCfdiString);
    }

    if (customregimenString) {
      this.customListRegimen = JSON.parse(customregimenString);
      this.customListRegimen.forEach(elem => {
        elem.value = elem.value.toString()
      });
      this.isLoading_usoRegimen=true
    }
  }
  
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); // Remover caracteres no numéricos
    this.sendDataReceptor(); // Llamar al método para enviar datos cuando cambie el valor
  }  

  public sendDataReceptor(): void {    
    for (const controlName in this.formReceptor.controls) {
      if (this.formReceptor.controls[controlName].value === "") {
        this.formReceptor.controls[controlName].reset();
      }
    }

    this.send_data_receptor.emit(this.formReceptor.value);
    this.send_validation_receptor.emit(this.formReceptor.valid);
  }


  
}
